import {
  formatReceieveOfferDates,
  receiveAndFormatOfferGroups,
} from '../../../../../common/lib/ReceiveAndFormatDates';
import { receiveOfferPromotion } from '../../../../../common/lib/OfferPromotion/offerPromotion';
import cloneDeep from 'lodash/cloneDeep';

/**
 * Formats offer data to be stored in Redux
 * @param { Object } offer
 * @param { String / Boolean } flag - relative dates flag
 * @param { Boolean } isIncomplete - If it is a new, unsaved offer
 * @return { Object } Offer - formatted offer object ready for redux
 */
const receiveOffer = (offer, flag, isIncomplete, onPrices) => {
  const formattedOffer = {};
  const offerCopy = cloneDeep(offer);
  const axsPromotion = receiveOfferPromotion(offerCopy, 'offer', flag);
  const groups = receiveAndFormatOfferGroups(
    offerCopy,
    flag,
    isIncomplete,
    onPrices
  );
  const dates = formatReceieveOfferDates(offerCopy, isIncomplete, flag);
  const offerImage = offerCopy.offerImage || '';
  const offerMobileImage = offerCopy.offerMobileImage || '';
  return Object.assign(
    formattedOffer,
    offerCopy,
    { axsPromotion },
    { groups },
    { dates },
    { offerImage },
    { offerMobileImage }
  );
};

export default receiveOffer;



// WEBPACK FOOTER //
// ./src/routes/EventDetails/routes/EditOffer/helpers/receiveOffer.js